import Dispatcher from '../../dispatcher';
import HttpRequestConstants from '../../constants/http_request';
import HTTP_REQUEST_KEYS from "../../constants/http_request_keys";

function fittingOptionsComputeStarted() {
  Dispatcher.handleHttpRequestAction({
    type: HttpRequestConstants.PRODUCT_MIXED_STOCKS_FITTING_OPTIONS_COMPUTE_STARTED,
  });
}

function fittingOptionsComputeSuccess() {
  Dispatcher.handleHttpRequestAction({
    type: HttpRequestConstants.PRODUCT_MIXED_STOCKS_FITTING_OPTIONS_COMPUTE_SUCCESS,
  });
}

function fittingOptionsComputeFailed() {
  Dispatcher.handleHttpRequestAction({
    type: HttpRequestConstants.PRODUCT_MIXED_STOCKS_FITTING_OPTIONS_COMPUTE_FAILED,
  });
}

function fittingOptionsComputeReset() {
  Dispatcher.handleHttpRequestAction({
    type: HttpRequestConstants.RESET_STATUS,
    payload: HTTP_REQUEST_KEYS.PRODUCT_MIXED_STOCKS_FITTING_OPTIONS_COMPUTE,
  });
}

export {
  fittingOptionsComputeStarted,
  fittingOptionsComputeSuccess,
  fittingOptionsComputeFailed,
  fittingOptionsComputeReset
};
